module.exports = __webpack_public_path__ + "img/key-warm.f43462fa.png";